import { createStore } from 'satcheljs';
import SearchResultsOptionState from './schema/SearchResultsOptionState';

export const getStore = createStore<SearchResultsOptionState>('searchResultsOption', {
    excludeDeletedItemsInSearch: null,
    scopeToInboxFolder: null,
});

export default getStore;
